// import axios from "axios";
// import { saveAs } from "file-saver";
// import React, { useContext, useEffect, useState } from "react";
// import { FaCloudDownloadAlt } from "react-icons/fa";
// import { IoInformationCircle } from "react-icons/io5";
// import styled from "styled-components";
// import { GlobalState } from "../../GlobalState";
// import Loading from "../utils/loading";
// import Tooltip from "../utils/Tooltip";
// import LineGraph from "./LineGraph";




// const Container = styled.div`
//   background-color: #fff;
//   // max-height: fit-content;
//   height: 100%;
//   padding: 1rem;
//   box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
//   width: 100%;
//   border-radius: 20px;
// `;


// const GraphWrapper = styled.div`
//   margin: 2rem auto;
//   background-color: #fff;
//   padding: 1rem;
//   box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
//   border-radius: 20px;
// `;
// const Header = styled.div`
//   float:right;
// `;

// const DownloadBtn = styled.button`
//   cursor: pointer;
//   background: none;
//   outline: none;
//   border: none;
//   margin: 0 1rem;
//   color: grey;

//   &:hover {
//     color: green;
//   }
// `;
// function TodayReport({ sensor_id, sensor_type, toShow }) {


//   const state = useContext(GlobalState);
//   const [loading, setLoading] = useState(true);
//   const [Data, setData] = useState([]);
//   const [Data2, setData2] = useState(null);


//   var date = new Date().toLocaleDateString();
//   const saveCanvas1 = () => {
//     //save to png
//     const canvasSave = document.getElementById("canvas1");
//     // add background color to canvas
//     // const ctx = canvasSave.getContext("2d");
//     // ctx.fillStyle = "#fff";

//     // canvasSave.style.backgroundColor = "#fff";

//     // canvasSave.toBlob(function (blob) {
//     //   saveAs(blob, `${date}___${sensor_type}.jpg`);
//     // });

//     const imageLink = document.createElement('a');

//     imageLink.download = 'img.png';
//     imageLink.href = canvasSave.current.toBase64Image('image/jpg', 1);

//     imageLink.click();

//   };
//   const saveCanvas2 = () => {
//     //save to png
//     const canvasSave = document.getElementById("canvas2");
//     // const ctx = canvasSave.getContext("2d");
//     // ctx.fillStyle = "#fff";
//     // canvasSave.style.backgroundColor = "#fff";

//     // canvasSave.toBlob(function (blob) {
//     //   saveAs(blob, `${date}___${sensor_type}`);
//     // });



//     const imageLink = document.createElement('a');

//     imageLink.download = 'img.png';
//     imageLink.href = canvasSave.current.toBase64Image('image/jpg', 1);

//     imageLink.click();
//   };

//   useEffect(() => {

//     async function fetchData(token) {
//       try {
//         const data = await axios.get(`${process.env.REACT_APP_API}/sensor/report?sensor_id=${sensor_id}&limit=${`48`}&type=${`daily`}&sensor_type=${sensor_type}`,
//           {
//             headers: { Authorization: token[0] },
//           }
//         );



//         if (sensor_type === 'Humidity' && toShow === 'Temperature') {
//           const data2 = await axios.get(
//             `${process.env.REACT_APP_API}/sensor/report?sensor_id=${sensor_id}&limit=${`48`}&type=${`daily`}&sensor_type=${'Temperature'}`,
//             {
//               headers: { Authorization: token[0] },
//             }
//           );
//           if (data2) {
//             setData2(data2.data);
//             setLoading(false);
//           }

//         }

//         if (data) {
//           setData(data.data);
//           setLoading(false);
//         }
//       } catch (err) {
//         console.log(err);
//       }
//     }

//     fetchData(state.token);
//   }, [state.token, sensor_id, sensor_type, toShow]);


//   if (loading)
//     return (
//       <div>
//         <Loading />
//       </div>
//     );
//   return (
//     <div>

//       {Data2 && sensor_type === 'Humidity' && toShow === 'Temperature' ? (
//         <Container>
//           <Header>
//             {/* <DownloadBtn title={"Download graph 2"}>
//               <FaCloudDownloadAlt onClick={saveCanvas2} size={25} />
//             </DownloadBtn>
//             <Tooltip
//               content={
//                 <>
//                   Hang tight! Sometimes it may take <br /> upto 5 sec to generate
//                   report.
//                 </>
//               }
//               direction="left"
//               delay="0"
//             >
//               <IoInformationCircle size={25} style={{ color: "grey" }} />
//             </Tooltip> */}
//           </Header>
//           <GraphWrapper>
//             <LineGraph
//               type={'Temperature'}
//               id={"canvas2"}
//               timestamps={Data2.timestamps}
//               data={Data2.datas}
//               unit={Data2.unit}
//             />
//           </GraphWrapper>
//         </Container>
//       ) : (
//         <Container>
//           <Header>

//             {/* <DownloadBtn title={"Download graph 3"}>
//               <FaCloudDownloadAlt onClick={saveCanvas1} size={25} />
//             </DownloadBtn> */}

//             {/* <Tooltip
//               content={
//                 <>
//                   Hang tight! Sometimes it may take <br /> upto 5 sec to generate
//                   report.
//                 </>
//               }
//               direction="left"
//               delay="0"
//             >
//               <IoInformationCircle size={25} style={{ color: "grey" }} />
//             </Tooltip> */}
//           </Header>

//           <GraphWrapper>
//             <LineGraph
//               id={"canvas1"}
//               type={sensor_type}
//               timestamps={Data.timestamps}
//               data={Data.datas}
//               unit={Data.unit}
//             />
//           </GraphWrapper>
//         </Container>)

//       }
//     </div>
//   );
// }

// export default TodayReport;

import axios from "axios";
import React, {
  useContext,
  useEffect,
  useState,
  useRef,
  forwardRef,
  useImperativeHandle,
} from "react";
import styled from "styled-components";
import { GlobalState } from "../../GlobalState";
import Loading from "../utils/loading";
import LineGraph from "./LineGraph";
import { sumList } from "../utils/utils";
import moment from "moment";

const Container = styled.div`
  background-color: #fff;
  height: 100%;
  padding: 1rem;
  // box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  width: 100%;
  border-radius: 20px;
`;

const GraphWrapper = styled.div`
  margin: 2rem auto;
  background-color: #fff;
  padding: 1rem;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  border-radius: 20px;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
`;

const Highlight = styled.h3`
  // color: var(--primary);
    color: #004080;
`;

const Highlight1 = styled.span`
  color: var(--primary);
  font-weight: bold;
`;

const TodayReport = forwardRef(
  ({ sensor_id, sensor_type, toShow, startDate, endDate, motor_id, location }, ref) => {
    const state = useContext(GlobalState);
    const exportRef = useRef();
    const [loading, setLoading] = useState(true);
    const [Data, setData] = useState(null);
    const [Data2, setData2] = useState(null);

    const [dateRange, setDateRange] = useState({
      start: startDate || moment().startOf("day").format("YYYY-MM-DD HH:mm:ss"),
      end: endDate || moment().endOf("day").format("YYYY-MM-DD HH:mm:ss"),
    });

    useImperativeHandle(ref, () => ({
      getElement: () => exportRef.current,
    }));

    const getInputValue = (value) => {
  if (value === null || value === undefined || isNaN(value)) return 0;
  return Number(value);
};

    useEffect(() => {
      if (!sensor_id || !sensor_type) return;

      async function fetchData(token) {
        setLoading(true);
        try {
          let trendUrl = `/sensor/date-wise-report?sensor_id=${sensor_id}&sensor_type=${encodeURIComponent(
            sensor_type
          )}&start_date=${dateRange.start}&end_date=${dateRange.end}`;
          if (motor_id && motor_id !== "undefined")
            trendUrl += `&motor_id=${motor_id}`;

          const { data } = await axios.get(
            `${process.env.REACT_APP_API}${trendUrl}`,
            { headers: { Authorization: token[0] } }
          );

          if (data?.datas?.length) data.total = sumList(data.datas);
          setData(data);

          if (sensor_type === "Humidity" && toShow === "Temperature") {
            let trendUrl2 = `/sensor/date-wise-report?sensor_id=${sensor_id}&sensor_type=Temperature&start_date=${dateRange.start}&end_date=${dateRange.end}`;
            if (motor_id && motor_id !== "undefined")
              trendUrl2 += `&motor_id=${motor_id}`;

            const { data: data2 } = await axios.get(
              `${process.env.REACT_APP_API}${trendUrl2}`,
              { headers: { Authorization: token[0] } }
            );

            if (data2?.datas?.length) data2.total = sumList(data2.datas);
            setData2(data2);
          } else {
            setData2(null);
          }
        } catch (err) {
          console.error("TodayReport fetch error:", err);
          setData(null);
          setData2(null);
        } finally {
          setLoading(false);
        }
      }

      fetchData(state.token);
    }, [
      state.token,
      sensor_id,
      sensor_type,
      toShow,
      motor_id,
      dateRange.start,
      dateRange.end,
    ]);

        useEffect(() => {
        setDateRange({
          start: startDate || moment().startOf("day").format("YYYY-MM-DD HH:mm:ss"),
          end: endDate || moment().endOf("day").format("YYYY-MM-DD HH:mm:ss"),
        });
      }, [startDate, endDate]);

    if (loading) return <Loading />;

    if (!Data || !Data.timestamps || !Data.timestamps.length) {
      return (
        <Container>
          <p>No data available for this date.</p>
        </Container>
      );
    }
    return (
      <Container ref={exportRef}>
        <Header>
          <div>
            {/* <Highlight>{sensor_type}</Highlight> */}
            {/* <Highlight>Trend</Highlight> */}
            <Highlight>{location || "Unknown Location"}</Highlight>
 
            <h5>
            {`Trend From ${moment(dateRange.start).format("DD MMM YYYY")} to ${moment(
              dateRange.end
            ).format("DD MMM YYYY")}`}
          </h5>
          </div>
        </Header>

          <LineGraph
            id="primaryGraph"
            type={sensor_type}
            timestamps={Data.timestamps}
            data={Data.datas}
            unit={Data.unit}
          />

        {Data2 && Data2.timestamps?.length > 0 && (
          <GraphWrapper>
            <LineGraph
              id="secondaryGraph"
              type="Temperature"
              timestamps={Data2.timestamps}
              data={Data2.datas}
              unit={Data2.unit}
            />
          </GraphWrapper>
        )}
      </Container>
    );
  }
);

export default TodayReport;
